import React, { Component } from "react";
import { Route, withRouter } from "react-router-dom";
import { create } from "jss";
import rtl from "jss-rtl";
import { StylesProvider, jssPreset, ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core";
import PrivateRoute from "./PrivateRoute";

import Login from "./components/Authentication/Login/login.component";
import Dashboard from "./components/Menu/menu.component";
import ForgetPass from "./components/Authentication/Login/ForgetPassword";

import "./App.css";

const theme = createMuiTheme({
  direction: "rtl",
  typography: {
    fontFamily: '"iransans", "yekan"',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      monsters: [],
    };
  }

  componentDidMount() {
    // IsAuthorized()
    // .then(result => {
    //   if(result.status === 401){
    //     this.props.history.push('/login');
    //   } else
    if (this.props.location.pathname === "/") {
      this.props.history.push("/login");
    }
    //   }
    // })
    // .catch((error) => {
    //   console.error(error);
    // });
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        <StylesProvider jss={jss}>
          <Route exact path='/' component={Login} />
          <Route exact path='/forgetpass' component={ForgetPass} />
          <Route exact path='/login' component={Login} />
          <PrivateRoute path='/main'>
            <Dashboard />
          </PrivateRoute>
        </StylesProvider>
      </ThemeProvider>
    );
  }
}

export default withRouter(App);
